/**
 * Footer event models (order-form / consumer side).
 * Duplicated from app footer events — no import from footer module.
 * Source: apps/kala-mobile/src/app/components/footer/events/footer-events.model.ts
 */

export interface FooterConfigurationToFooter {
	visible?: boolean;
}

export const ORDER_FORM_FOOTER_EVENTS = {
	FOOTER_CONFIGURATION: 'footer.configuration'
} as const;
